import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function IubireProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1535">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1536">
        <SectionHeading title="Te simți singur/ă chiar și atunci când ești înconjurat/ă de oameni?" data-id="element-1537" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-1538">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-1539">
            <p className="font-bold text-xl text-brand-text" data-id="element-1540">
              Poate ești într-o relație, dar te simți singur/ă. Poate ai oameni
              în jurul tău, dar nu te simți cu adevărat văzut/ă sau iubit/ă.
            </p>
            <p data-id="element-1541">
              Porți răni din trecut pe care nu le-ai procesat niciodată:
              resentimente, dezamăgiri, momente în care ai simțit că nu ești
              suficient de bun/ă sau demn/ă de iubire. Și poate cel mai greu
              lucru e că nu reușești să te iubești pe tine. Te judeci, te
              critici, te pui mereu pe ultimul loc.
            </p>
            <p data-id="element-1542">
              Cu fiecare zi în care aceste răni rămân nevindecate, golul
              interior crește. Încrederea în oameni scade. Relațiile devin mai
              tensionate sau mai superficiale. Și începi să crezi că poate asta
              e tot ce poți avea. Că iubirea adevărată, profundă, autentică, nu
              e pentru tine. Dar nu e adevărat.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-1543">
              <p className="font-medium text-brand-text italic" data-id="element-1544">
                Cursul Abundența Iubirii te ghidează pas cu pas să descoperi
                tipurile de iubire, să înveți să te iubești pe tine prin
                exerciții practice, să eliberezi resentimentele și rănile din
                trecut, să practici iertarea și să te reconectezi la iubire
                autentică. Include meditații ghidate pentru creșterea vibrației
                energetice și pentru experimentarea iubirii la un nivel profund.
                Nu e un curs teoretic. E un curs în care simți și trăiești
                iubirea.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1545">
          <CTAButton data-id="element-1546" />
        </motion.div>
      </div>
    </section>;
}